import React from 'react'

import { Bar, BarChart, BarChartProps, BarProps, CartesianGrid, ResponsiveContainer, Tooltip, XAxis } from 'recharts'

const FIVE_SECONDS = 5000

export interface ChartProps {
    data: BarChartProps['data']
    onAnimationEnd?: BarProps['onAnimationEnd']
}

export const Chart: React.FC<ChartProps> = ({ data, onAnimationEnd }: ChartProps) => {
    const [chartReadyForHover, setChartReadyForHover] = React.useState(false)

    const handleAnimationEnd = (): void => {
        // Wait an additional 5 seconds before displaying chart hover
        // Tooltip and cursor to prevent affecting rendered pdf
        setTimeout(() => setChartReadyForHover(true), FIVE_SECONDS)

        if (typeof onAnimationEnd === 'function') {
            onAnimationEnd()
        }
    }

    return data ? (
        <ResponsiveContainer width="100%" aspect={5 / 2}>
            <BarChart
                data={data}
                margin={{
                    top: 20,
                    bottom: 20,
                }}
            >
                <CartesianGrid stroke="#eee" strokeDasharray="5 5" />
                <XAxis
                    dataKey="date"
                    tickFormatter={(d): string =>
                        new Date(d).toLocaleDateString(undefined, {
                            month: 'numeric',
                            day: 'numeric',
                        })
                    }
                />
                <Tooltip
                    content={chartReadyForHover ? undefined : (): null => null}
                    cursor={chartReadyForHover}
                    labelFormatter={(val): string => {
                        if (typeof val === 'number' || typeof val === 'string') {
                            return new Date(val).toLocaleDateString()
                        }
                        return val
                    }}
                />
                <Bar onAnimationEnd={handleAnimationEnd} dataKey="amount" fill="#009688" />
            </BarChart>
        </ResponsiveContainer>
    ) : null
}
